import { useEffect, useState } from "react";
import $api from "@/zapi-frontend/shared/api/axios";
import { toast } from "sonner";
import { TGetProjectResponse } from "@/zapi-frontend/shared/types/projects";

export function useProject(id: string | null) {
  const [project, setProject] = useState<TGetProjectResponse | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    $api
      .get<{ data: TGetProjectResponse }>(`/projects/${id}`)
      .then((r) => {
        const d = r.data.data;
        setProject(d);
      })
      .catch(() => {
        toast.error("Failed to load stages");
      })
      .finally(() => setLoading(false));
  }, [id]);

  return { project, loading };
}
